// 質問を開く共通処理
function openQuestion(question) {
  if (!question) return

  // 既に開いている場合はスキップ
  if (!question.classList.contains('active')) {
    question.click()
  }
}

window.addEventListener('DOMContentLoaded', () => {
  // URLアンカーがある場合、該当する質問を開く
  const hash = window.location.hash
  if (hash) {
    const question = document.querySelector(hash)
    if (question) {
      openQuestion(question)
      question.scrollIntoView({ behavior: 'smooth' })
    }
  }

  document.querySelectorAll('.js-top-q-link').forEach((dom) => {
    dom.addEventListener('click', (e) => {
      const target = e.currentTarget
      const id = target.getAttribute('href')
      const question = document.querySelector(id)
      openQuestion(question)
    })
  })
})
